import type { FC } from 'react';

import type { Hotkey } from 'config/enums';
import { HorizontalButtonContainer } from 'features/call/call-details/styles';
import {
  CallDetailsButtonDeafDisconnect,
  CallDetailsButtonDeafThreeDotMenu,
} from 'features/call/call-details/components';

interface CallDetailsDeafConnectedButtonsProps {
  isLoadingDeaf: boolean;
  isThreeDotsMenuButtonPresent: boolean;
  hotkey?: Hotkey;
}

export const CallDetailsDeafConnectedButtons: FC<
  CallDetailsDeafConnectedButtonsProps
> = ({ isLoadingDeaf, isThreeDotsMenuButtonPresent, hotkey }) => (
  <HorizontalButtonContainer>
    <CallDetailsButtonDeafDisconnect
      isLoading={isLoadingDeaf}
      hotkey={hotkey}
    />
    {isThreeDotsMenuButtonPresent && <CallDetailsButtonDeafThreeDotMenu />}
  </HorizontalButtonContainer>
);
